import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { FieldErrorMessage, IsFieldValid } from "../../utils/formValidator";
import { InputTextarea } from "primereact/inputtextarea";

const ArfInputTextarea = (props: any) => {
  const { t } = useTranslation();
  return (
    <div className={`${props.className ? props.className : 'col-12 lg:col-6'}`}>
      <label
        htmlFor={props.name}
        className={classNames("block mb-2 text-color font-bold", {
          "p-error": IsFieldValid(props.formik, props.name),
        })}
      >
        {t(props.label)}
      </label>
      <div style={{ height: "134px" }}>
        <InputTextarea
          id={props.name}
          value={props.formik.values[props.name]}
          onChange={props.formik.handleChange}
          className={classNames("w-full h-full pb-3", {
            "p-invalid": IsFieldValid(props.formik, props.name),
          })}
        />
      </div>
      {FieldErrorMessage(props.formik, props.name)}
    </div>
  );
};

export default ArfInputTextarea;
